import React from "react";
import { createPortal } from "react-dom";

function VersionModalContainer({ children }) {
  return createPortal(<>{children}</>, document.getElementById("version_modal"));
}

export default VersionModalContainer;